import { TaglinePill } from "./TaglinePill";
import { PathCard } from "./PathCard";
import { TrustBadges } from "./TrustBadges";

export function HomeHero() {
  return (
    <section className="relative flex-1 flex flex-col items-center justify-center bg-primary py-12 lg:py-16 overflow-hidden">
      {/* Background Decorative Dots */}
      <DecorativeDots />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center gap-12 px-4 sm:px-6 lg:px-8">
        {/* Header Group */}
        <div className="flex flex-col items-center gap-4">
          <TaglinePill />
          <h1 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-white text-center">
            Choose Your Path
          </h1>
          <p className="text-lg md:text-xl text-white/[0.67] text-center">
            For Individuals &amp; Treatment Providers
          </p>
        </div>

        {/* Path Cards */}
        <div className="flex flex-col md:flex-row gap-8 md:gap-10 justify-center">
          <PathCard variant="individual" />
          <PathCard variant="treatment" />
        </div>

        {/* Trust Badges */}
        <TrustBadges />
      </div>
    </section>
  );
}

// Dot pattern overlay matching /centers hero
function DecorativeDots() {
  return (
    <div
      className="absolute inset-0 pointer-events-none opacity-[0.15]"
      style={{
        backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.8) 1px, transparent 1px)",
        backgroundSize: "24px 24px",
      }}
    />
  );
}
